<template>
  <div class="container">
    <div v-for="(store, index) in storeCartList">

      <div class="cart-item" :show-border="true">
        <div>
          <div class="store">
            <i class="iconfont">&#xe62d;</i>
            <!-- <span
              @click="$router.push({ name: 'HomeStoredetail', query: { id: store.store_id } })">{{ store.store_name }}</span> -->
            <span>{{ store.store_name }}</span>
          </div>
          <div class="buy-item" v-for="goods in store.goods_list">
            <!-- <div class="goods-pic"><img :src="goods.goods_image_url"
                @click="$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods.goods_id } })" /></div> -->
            <div class="goods-pic"><img :src="goods.goods_image_url" /></div>
            <div class="goods-info">
              <dl>
                <dt class="goods-name">
                  <i class="tag-icon" v-if="goods.xianshi_info">{{ goods.xianshi_info.xianshi_title }}</i>
                  <i class="tag-icon" v-if="goods.ifgroupbuy">抢购</i>
                  <i class="tag-icon" v-if="goods.ifmgdiscount">会员折扣</i>
                  <i class="tag-icon" v-if="goods.ifpintuan">拼团</i>
                  <i class="tag-icon" v-if="goods.ifbargain">砍价</i>
                  <i class="tag-icon" v-if="goods.bl_id">优惠套装</i>
                  {{ goods.goods_name }}
                </dt>
                <dd class="goods-subtotal">
                  <span class="goods-price">${{ goods.goods_price }}</span><span
                    v-if="goods.goods_price < goods.goods_original_price" class="ml-5 goods-original-price">${{
                      goods.goods_original_price }}</span>
                  <span class="goods-count">×{{ goods.goods_num }}</span>
                </dd>
                <dd>
                  <div class="link" v-if="goodsCount > 1 && chainList[goods.goods_id] && chainList[goods.goods_id].length"
                    @click="goBuy(goods.goods_id, goods.goods_num)">当前地区可以使用自提点(选择自提点后只能单个商品结算)</div>
                  <div v-else>
                    <div class="link" v-if="addressApi.allow_offpay == 1 && ifshowOffpay && offlineList[goods.goods_id]">
                      该商品支持货到付款</div>
                  </div>
                  <div class="link" v-if="goods.limit == true">该商品不支持配送到此收货地址</div>
                </dd>
              </dl>
            </div>

          </div>
          <!-- <div class="buy-item"
            v-if="store.store_mansong_rule_list && store.store_mansong_rule_list.goods_id != 0 && store.store_mansong_rule_list.mansong_goods_name != ''"
            @click="$router.push({ name: 'HomeGoodsdetail', query: { goods_id: store.store_mansong_rule_list.goods_id } })"> -->
          <div class="buy-item"
            v-if="store.store_mansong_rule_list && store.store_mansong_rule_list.goods_id != 0 && store.store_mansong_rule_list.mansong_goods_name != ''">
            <div class="goods-pic"><img :src="store.store_mansong_rule_list.goods_image_url" /></div>
            <div class="goods-info">
              <dl>
                <dt class="goods-name">
                  <i class="tag-icon">赠品</i>
                  {{ store.store_mansong_rule_list.mansong_goods_name }}
                </dt>
                <dd class="goods-subtotal">
                  <span class="goods-price">$0.00</span>
                  <span class="goods-count">×1</span>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      
      <div class="cart-subtotal">

        <div v-if="chainCount[store.store_id] > 0" @click="toggleChain(store.store_id)">
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <div>
              <span class="left-icon iconfont">&#xe6d3;</span>
              <span>自提门店</span>
            </div>
            <span slot="right">{{ chainInfo[store.store_id] ? chainInfo[store.store_id].chain_addressname : '请选择'
            }}</span>
          </flex-line>
        </div>

        <div v-if="store.store_voucher_list.length" @click="toggleVoucher(store.store_id)">
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <div>
              <span class="left-icon iconfont">&#xe6f2;</span>
              <span>代金券</span>
            </div>
            <span slot="right">{{ myVoucher[store.store_id] }}</span>
          </flex-line>
        </div>
        
        <div class="message">
          <div class="div field-line-right"><textarea class="order-message field-input"
              @change="changeMessage(store.store_id)" v-model="message[store.store_id]"
              :placeholder="$t('Store order message')"></textarea>
          </div>
        </div>

        <checkout-desc class="desc-item mt-5" :title="$t('productAmount')"
          :subtitle="store.store_goods_original_total"></checkout-desc>

        <checkout-desc class="desc-item" :title="$t('discount')"
          v-if="store.store_mansong_rule_list || store.store_goods_discount_total > 0"
          :subtitle="Math.round(((store.store_mansong_rule_list.discount ? parseFloat(store.store_mansong_rule_list.discount) : 0) + parseFloat(store.store_goods_discount_total)) * 100) / 100"
          :discount="true"></checkout-desc>

        <checkout-desc class="desc-item" :title="$t('shippingFee')" v-if="addressApi"
          :subtitle="chainInfo[store.store_id] ? 0 : (addressApi.state == 'fail' ? 0 : addressApi.content[store.store_id])"></checkout-desc>

        <checkout-desc class="desc-item" :title="$t('subtotal')"
          :subtitle="totalAmount[store.store_id]"></checkout-desc>
      </div>

      <mt-popup v-model="voucherVisible[store.store_id]" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="代金券" class="common-header">
            <mt-button slot="left" icon="back" @click="toggleVoucher(store.store_id)"></mt-button>
            <div class="common-btn btn" slot="right" @click="selectVoucher('', store.store_id)">不使用</div>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <div class="common-voucher common-voucher02" :class="(item.voucher_state != 1) ? 'disable' : ''"
            v-for="(item, index) in store.store_voucher_list" :key="item.voucher_id"
            @click="selectVoucher(item, store.store_id)">
            <div class="par">
              <p>订单满{{ item.voucher_limit }}元</p><sub class="sign">$</sub><span>{{ item.voucher_price }}</span>
            </div>
            <div class="copy">有效期至<p><br>{{ $moment.unix(item.voucher_enddate).format('YYYY.MM.DD') }}</p>
            </div>
            <i></i>
          </div>
        </div>
      </mt-popup>
      <mt-popup v-model="chainVisible[store.store_id]" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="自提门店" class="common-header">
            <mt-button slot="left" icon="back" @click="toggleChain(store.store_id)"></mt-button>
            <div class="common-btn btn" slot="right" @click="selectChain('', store.store_id)">不使用</div>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <div class="chain-item" v-for="(chain, i) in chainList[store.store_id]" :key="i"
            @click="selectChain(chain, store.store_id)">
            <div class="chain-name">{{ chain.chain_addressname }}</div>
            <div class="chain-desc">{{ chain.chain_area_info }}{{ chain.chain_address }}</div>
          </div>
        </div>
      </mt-popup>

    </div>
  </div>
</template>

<script>
import { getbuyChainList } from '../../../../api/memberBuy'
import CheckoutDesc from './CheckoutDesc'
import flexLine from '../../../flexLine'
export default {
  name: 'CheckoutStore',
  data() {
    return {

      totalAmount: {},
      myVoucher: [],
      voucherVisible: [],
      message: [],
      chainList: {},
      offlineList: {},
      goodsCount: 0,
      chainCount: [],
      chainVisible: [],
      chainInfo: [],
      goodsInfo: false
    }
  },
  components: {
    flexLine,
    CheckoutDesc
  },
  props: ['payGoodsList', 'addressInfo', 'storeCartList', 'addressApi', 'finalTotalList', 'ifshowOffpay'],
  created: function () {
    if (this.payGoodsList.offline) {
      var offlineList = {}
      for (var i in this.payGoodsList.offline) {
        offlineList[this.payGoodsList.offline[i].goods_id] = 1
      }
      this.offlineList = offlineList
    }
    for (var store_id in this.storeCartList) {
      this.calcOrder(store_id)
      if (this.addressInfo) {
        var goods_list = JSON.stringify(this.storeCartList[store_id].goods_list)
        this.getbuyChainList(goods_list, this.addressInfo.area_id, store_id)
      }
    }
  },

  methods: {
    goBuy(goods_id, goods_num) {
      var params = { buy_now: 1, cart_id: goods_id + '|' + goods_num }
      this.$router.push({ name: 'MemberBuyStep1', query: params })
      this.$router.go(0)
    },
    selectChain(chain, store_id) {
      if (chain === '') {
        this.chainInfo[store_id] = ''
      } else {
        this.chainInfo[store_id] = chain
      }

      this.calcOrder(store_id)
      this.chainVisible.splice(store_id, 1, !this.chainVisible[store_id])
      this.$emit('selectChain', this.chainInfo, store_id)
    },
    getbuyChainList(goods_list, area_id, store_id) {
      getbuyChainList(goods_list, area_id).then(res => {
        this.chainList[store_id] = res.result.chain_list
        this.chainCount[store_id] = this.chainList[store_id].length
        this.$forceUpdate()
      })
    },
    changeMessage(store_id) {
      this.$emit('changeMessage', this.message[store_id], store_id)
    },
    selectVoucher(voucherInfo, store_id) {
      this.toggleVoucher(store_id)
      this.$emit('selectVoucher', voucherInfo, store_id)
      this.storeCartList[store_id].store_voucher_info = voucherInfo
      this.calcOrder(store_id)
    },
    calcOrder(store_id) {
      let price = parseFloat(this.finalTotalList[store_id])

      if (this.storeCartList[store_id].store_voucher_list.length) {
        if (this.storeCartList[store_id].store_voucher_info) {
          price -= parseFloat(this.storeCartList[store_id].store_voucher_info.voucher_price)
          if (typeof (this.myVoucher[store_id]) === 'undefined') {
            this.myVoucher[store_id] = ''
          }
          this.myVoucher.splice(store_id, 1, this.storeCartList[store_id].store_voucher_info.voucher_price + '元')
        } else {
          this.myVoucher.splice(store_id, 1, '不使用')
        }
      }
      if (this.chainInfo[store_id]) {
        price -= this.addressApi.content[store_id]
      }
      if (price < 0) {
        price = 0
      }
      this.totalAmount[store_id] = Math.round(price * 100) / 100
    },
    toggleVoucher(store_id) {
      if (typeof (this.voucherVisible[store_id]) === 'undefined') {
        this.voucherVisible[store_id] = false
      }
      this.voucherVisible.splice(store_id, 1, !this.voucherVisible[store_id])
    },
    toggleChain(store_id) {
      if (typeof (this.chainVisible[store_id]) === 'undefined') {
        this.chainVisible[store_id] = false
      }
      this.chainVisible.splice(store_id, 1, !this.chainVisible[store_id])
    }
  }
}
</script>

<style scoped lang="scss">
.common-header {
  .btn {
    background: #000;
    color: #fff;
    box-shadow: 0px 2px 4px #d2d2d2;
  }
}

.container {
  background: #fff;
  padding: 0 $pageSpace
}

.store {
  position: relative;
  z-index: 1;
  display: block;
  height: 0.9rem;
  padding: 0.5rem 0;
  font-size: $subFontSize;
  line-height: 0.9rem;
  background: #fff;
  font-weight: 700;
}

.store i {
  font-size: $h2;
  margin-right: 0.2rem;
  color: $primaryColor;
}

.cart-item {
  background-color: #FFF;
}

.buy-item {
  display: block;
  position: relative;
  z-index: 1;
  margin: .5rem 0;
  box-shadow: 0px 4px 4px #f7f7f7;
}

.buy-item .goods-pic {
  display: block;
  width: 3rem;
  height: 3rem;
  position: absolute;
  z-index: 1;
  top: 0rem;
  left: 0rem;
}

.buy-item .goods-pic img {
  width: 100%;
  height: 100%;
  border-radius: 0.2rem;
}

.buy-item .goods-info {
  display: block;
  // vertical-align: top;
  padding: .2rem 0;
  margin-left: 4rem;
  position: relative;
  z-index: 1;
}

.buy-item .goods-info .link {
  font-size: $subFontSize;
  color: $primaryColor;
  margin-top: .3rem
}

.buy-item .goods-info .goods-name {
  height: 1.6rem;
  font-size: $subFontSize;
  line-height: .8rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: box;
  line-clamp: 2;
  box-orient: vertical;
  margin-bottom: .5rem;
  font-weight: normal;

  .tag-icon {
    vertical-align: top
  }
}

.buy-item .goods-info .goods-type {
  overflow: hidden;
  white-space: nowrap;
  width: 70%;
  height: 0.9rem;
  font-size: $h6;
  line-height: 0.9rem;
  color: #999;
  text-overflow: ellipsis;
}

.buy-item .goods-info .goods-original-price {
  text-decoration: line-through;
  font-size: $fontSize;
  color: $descTextColor;
  font-weight: normal
}

.buy-item .goods-info .goods-subtotal {
  display: block;
  height: 1rem;
  margin: 0 0.5rem 0 0rem;
  line-height: 1rem;
  font-size: $subFontSize;
  position: relative;
  z-index: 1;
}

.buy-item .goods-info .goods-subtotal .goods-price {
  color: #DB4453;
  font-size: $subFontSize;
  font-weight: 600;
}

.buy-item .goods-info .goods-subtotal .goods-count {
  font-size: $subFontSize;
  line-height: 1rem;
  position: absolute;
  z-index: 1;
  top: 0rem;
  right: 0rem;
  font-weight: normal;
  color: $descTextColor
}

// .cart-subtotal {}

.cart-subtotal dl {
  position: relative;
  z-index: 1;
  height: 1rem;
  padding: 0.4rem 0 0;
  font-size: 0;
}

.cart-subtotal dt {
  position: absolute;
  z-index: 1;
  top: 0.4rem;
  left: 0.4rem;
  display: block;
  width: 50%;
  height: 1rem;
  font-size: $fontSize;
  line-height: 1rem;
}

.cart-subtotal dd {
  height: 1rem;
  margin: 0 0.5rem 0 50%;
  text-align: right;
  font-size: $fontSize;
  line-height: 1rem;
}

.cart-subtotal .message {
  position: relative;
  z-index: 1;
  display: block;
  border-bottom: 1px dashed #eee;

  .order-message {
    background: #FBFBFB;
    margin: .5rem 0;
    font-size: $fontSize;
    padding: .5rem;
    height: 4rem;
    border: 0;
    box-sizing: border-box;
    width: 100%;
  }
}

.desc-item {
  height: 1.5rem;
}

.common-voucher {
  margin: 0.5rem auto
}

.left-icon {
  float: left;
  font-size: $h1;
  margin-right: 0.2rem;
}

.chain-item {
  padding: .5rem;
}

.chain-item .chain-name {
  font-size: $h2;
  margin-bottom: .3rem
}

.chain-item .chain-desc {
  font-size: $fontSize;
  color: #666
}
</style>
